import React from 'react';
import { ITabItem } from './common';

const TabContainer: React.FC<ITabItem> = props => props.children;

export default TabContainer;